import { DocumentThumbnail, VideoThumbnail, StaticVideo } from '../types/items';

const sortDocumentThumbnails = (thumbnails: DocumentThumbnail[]) => [...thumbnails].sort((a, b) => b.width - a.width);

const sortVideoThumbnails = (thumbnails: VideoThumbnail[]) => [...thumbnails].sort((a, b) => b.width - a.width);

const sortStaticVideo = (videos: StaticVideo[]) => [...videos].sort((a, b) => b.width - a.width);

export const getDocumentThumbnailUrl = (thumbnails: DocumentThumbnail[], width: number = 500): string => {
  if (thumbnails.length > 0) {
    const sorted = sortDocumentThumbnails(thumbnails);
    const thumbnail = sorted.find((item) => width >= item.width) || sorted.find((item) => width < item.width);
    if (thumbnail !== undefined) {
      return thumbnail.signed_url.url;
    }
  }
  return '';
};

export const getLargeDocumentThumbnailUrl = (thumbnails: DocumentThumbnail[]): string => {
  if (thumbnails.length > 0) {
    return sortDocumentThumbnails(thumbnails)[0].signed_url.url;
  }
  return '';
};

export const getSmallDocumentThumbnailUrl = (thumbnails: DocumentThumbnail[]): string => {
  if (thumbnails.length > 0) {
    return sortDocumentThumbnails(thumbnails)[thumbnails.length - 1].signed_url.url;
  }
  return '';
};

export const getVideoThumbnailUrl = (thumbnails: VideoThumbnail[], width: number = 500): string => {
  if (thumbnails.length > 0) {
    const sorted = sortVideoThumbnails(thumbnails);
    const thumbnail = sorted.find((item) => width >= item.width) || sorted.find((item) => width < item.width);
    if (thumbnail !== undefined) {
      return thumbnail.url;
    }
  }
  return '';
};

export const getLargeVideoThumbnailUrl = (thumbnails: VideoThumbnail[]) => {
  if (thumbnails.length > 0) {
    return sortVideoThumbnails(thumbnails)[0].url;
  }
  return '';
};

export const getSmallVideoThumbnailUrl = (thumbnails: VideoThumbnail[]) => {
  if (thumbnails.length > 0) {
    return sortVideoThumbnails(thumbnails)[thumbnails.length - 1].url;
  }
  return '';
};

export const getQuality = (name: string) => {
  if (name.indexOf('medium') > -1) {
    return 'medium quality';
  }
  if (name.indexOf('high') > -1) {
    return 'high quality';
  }
  return 'low quality';
};

export const getStaticVideoUrl = (statics: StaticVideo[]): string | undefined => {
  if (statics.length > 0) {
    return sortStaticVideo(statics)[0].url;
  }
  return undefined;
};

export const getStaticVideo = (statics: StaticVideo[]): StaticVideo | undefined => {
  if (statics.length > 0) {
    return sortStaticVideo(statics)[0];
  }
  return undefined;
};
